import { oc } from '@orpc/contract'
import { z } from 'zod'

export const taskSubtaskSchema = z.object({
  id: z.string().min(1),
  taskId: z.string().min(1),
  title: z.string(),
  completed: z.boolean(),
  assigneeId: z.string().nullable().default(null),
  position: z.number().int(),
  createdAt: z.string(),
})

export const taskSubtasksListContract = oc
  .input(
    z.object({
      projectId: z.string().min(1),
      taskId: z.string().min(1),
    })
  )
  .output(
    z.object({
      items: z.array(taskSubtaskSchema),
    })
  )

export const taskSubtasksCreateContract = oc
  .input(
    z.object({
      projectId: z.string().min(1),
      taskId: z.string().min(1),
      title: z.string().min(1),
      assigneeId: z.string().nullable().optional(),
    })
  )
  .output(taskSubtaskSchema)

export const taskSubtasksUpdateContract = oc
  .input(
    z.object({
      projectId: z.string().min(1),
      taskId: z.string().min(1),
      subtaskId: z.string().min(1),
      title: z.string().min(1).optional(),
      completed: z.boolean().optional(),
      assigneeId: z.string().nullable().optional(),
    })
  )
  .output(taskSubtaskSchema)

export const taskSubtasksDeleteContract = oc
  .input(
    z.object({
      projectId: z.string().min(1),
      taskId: z.string().min(1),
      subtaskId: z.string().min(1),
    })
  )
  .output(z.object({ ok: z.literal(true) }))

export const taskSubtasksReorderContract = oc
  .input(
    z.object({
      projectId: z.string().min(1),
      taskId: z.string().min(1),
      subtaskIds: z.array(z.string().min(1)),
    })
  )
  .output(z.object({ ok: z.literal(true) }))
